export const state = {
  projectsFolderToMove: {},
  projectsFolderMoveDialogIsOpen: false,
  projectsFolderMovePending: false,
}
